// extracted by mini-css-extract-plugin
export default {"CategorySlider":"CategorySlider_CategorySlider__44o6s"};